// frontend/src/api/settingsAPI.js
import axios from 'axios';
import { API_BASE_URL, authHeader } from './axiosConfig';

const settingsAPI = {
  // Get full department × module matrix (admin only)
  getMatrix: () =>
    axios.get(`${API_BASE_URL}/settings/module-permissions`, { headers: authHeader() })
      .then(r => r.data),

  // Get current user's allowed modules
  getMyModules: () =>
    axios.get(`${API_BASE_URL}/settings/module-permissions/my`, { headers: authHeader() })
      .then(r => r.data),

  // Save permissions for one department (admin only)
  saveDepartment: (departmentId, modules) =>
    axios.put(`${API_BASE_URL}/settings/module-permissions/${departmentId}`, { modules }, { headers: authHeader() })
      .then(r => r.data),
};

export default settingsAPI;
